export const HYPERTENSION_RECORDS = () => {
    return {
        HYPERTENSION_QUESTION: {//section
            HYPERQ1: {//QuestionsetCd 
                YESNODATAELEMENT1: {//Dataelementcd
                    question: 'Have you ever been diagnosed as having high blood pressure?',
                    answer: ''
                },
                FREETEXT2: {
                    question: 'When was high blood pressure first diagnosed?',
                    answer: ''
                },
                FREETEXT1: {
                    question: 'Why was your Blood Pressure measured at that particular time? E.g. routine examinations, due to symptoms, etc.',
                    answer: ''
                }
            },
            HYPERQ2: {
                YESNODATAELEMENT1: {
                    question: 'Do you know what your Blood Pressure readings were at diagnosis?',
                    answer: ''
                },
                FREETEXT1: {
                    question: 'Please provide details',
                    answer: ''
                }
            },
            HYPERQ3: {
                YESNODATAELEMENT1: {
                    question: 'Have you had an ECG, X-Ray, Blood Lipid Test or other investigations done?',
                    answer: ''
                },
                FREETEXT1: {
                    question: 'Please provide details including dates of investigations & results and copies thereof.',
                    answer: ''
                },
                FREETEXT2: {
                    question: 'Please provide details of your treatment. Include names of medicines, dosage and how often taken.',
                    answer: ''
                },
                FREETEXT3: {
                    question: 'Currently',
                    answer: ''
                },
                FREETEXT4: {
                    question: 'In the past',
                    answer: ''
                },
                DATEELEMENT1: {
                    question: 'Regarding the monitoring of your condition',
                    answer: ''
                },
                FREETEXT5: {
                    question: 'Name the doctor in-charge of your follow-up',
                    answer: ''
                },
                FREETEXT6: {
                    question: 'How often do you attend for a follow-up?',
                    answer: ''
                },
                DATEELEMENT2: {
                    question: 'When was your last consultation? ',
                    answer: ''
                },
                FREETEXT7: {
                    question: 'Please provide details of your Blood Pressure reading at that time, if known',
                    answer: ''
                }
            },
            URINEANALYSIS: {
                YESNODATAELEMENT1: {
                    question: 'Have any abnormalities (e.g. protein, blood, etc) ever been found in your urine?',
                    answer: ''
                },
                FREETEXT1: {
                    question: 'Please provide date(s) and full details',
                    answer: ''
                }
            },
            HYPERQ4: {
                YESNODATAELEMENT1: {
                    question: 'Problem with your eyes / vision',
                    answer: ''
                },
                YESNODATAELEMENT2: {
                    question: 'Diabetes',
                    answer: ''
                },
                YESNODATAELEMENT3: {
                    question: 'Heart or circulatory trouble',
                    answer: ''
                },
                YESNODATAELEMENT4: {
                    question: 'Albumin or protein in your urine.',
                    answer: ''
                },
                YESNODATAELEMENT5: {
                    question: 'Giddiness etc.',
                    answer: ''
                },
            },
            WEEKOFF: {
                YESNODATAELEMENT1: {
                    question: 'Have you lost significant time (e.g. weeks) off work with this condition?',
                    answer: ''
                },
                FREETEXT1: {
                    question: 'Please provide details including dates and duration of time off work',
                    answer: ''
                }
            },
            ADDITIONALINFO: {
                YESNODATAELEMENT2: {
                    question: 'Have you ever been hospitalized on account of elevated blood pressure?',
                    answer: ''
                },
                FREETEXT1: {
                    question: 'Please provide any additional information on your condition, which you feel, will be helpful in processing your application?',
                    answer: ''
                }
            }
        }
    }

}


export const OTHERS_RECORDS = () => {
    return {
        OTHERS: {//section
            PEP: {//QuestionsetCd 
                YESNODATAELEMENT1: {//Dataelementcd
                    question: 'Are you a politically exposed person (PEP)*?',
                    answer: ''
                }
            },
            CRIMINAL: {
                YESNODATAELEMENT1: {
                    question: 'If there is any ongoing Conviction/criminal proceedings?',
                    answer: ''
                },
                ALPHABETWOSPECIALCHAR1: {
                    question: 'Details',
                    answer: ''
                }
            },
            TAXDETAILS: {
                YESNODATAELEMENT1: {
                    question: 'Today, are you a tax resident of any other country(ies), Other than India ?',
                    answer: ''
                }
            },
            TINSTATIC: {
                FREETEXT1: {
                    question: 'Please provide Name of such country(ies) and TIN with respect to each reportable jurisdiction:',
                    answer: ''
                }
            },
            TINDETAILS: {
                COUNTRYELEMENT2: {
                    question: 'Name of country',
                    answer: ''
                },
                TINELEMENT1: {
                    question: 'TIN / Functional Equivalent',
                    answer: ''
                },
                TINNUMELEMENT1: {
                    question: 'Number',
                    answer: ''
                }
            }
        }
    }
}

export const FEMALELIFE_RECORDS = () => {
    return {
        FEMALE_LIFE: {//section
            PREGNANCY: {//QuestionsetCd 
                YESNODATAELEMENT1: {//Dataelementcd
                    question: 'Are you pregnant?',
                    answer: ''
                },
                INTEGERELEMENT1: {
                    question: 'How many weeks?',
                    answer: ''
                }
            },
            FEMALEDISORDER: {
                YESNODATAELEMENT1: {
                    question: 'Have you, or have you ever had, any disorder of the female organs (breasts, ovaries, uterus) or any abnormality of pregnancy or confinement e.g. Caesarian section or miscarriage, high blood pressure, gestational diabetes, etc?',
                    answer: ''
                }
            },
            MEDICALDETAILS: {
                FREETEXT1: {
                    question: 'Medical Condition',
                    answer: ''
                },
                NUMWITHSLASH: {
                    question: 'Date of diagnosis',
                    answer: ''
                },
                FREETEXT3: {
                    question: 'Treatment given:',
                    answer: ''
                },
                FREETEXT4: {
                    question: 'Name of tablets or medications:',
                    answer: ''
                }
            },
            HOSPITALIZATION: {
                YESNODATAELEMENT2: {
                    question: 'Have you ever been hospitalized for this condition?',
                    answer: ''
                },
                FREETEXT1: {
                    question: 'Date of hospitalisation',
                    answer: ''
                }
            },
            FEMALEDISORDER2: {
                YESNODATAELEMENT9: {
                    question: 'Have you now fully recovered and stopped all medications?',
                    answer: ''
                },
                ALPHABETWITHSPECIALCHAR: {
                    question: 'Please provide details',
                    answer: ''
                }
            }
        }
    }
}

export const FAMILY_RECORDS = () => {
    return {
        FAMILY_HISTORY: {//section
            FAMILY: {//QuestionsetCd 
                RELATIONELEMENT1: {//Dataelementcd
                    question: 'Family Member',
                    answer: ''
                },
                YESNODATAELEMENT8: {
                    question: 'Is Living?',
                    answer: ''
                },
                INTEGERELEMENT1: {
                    question: 'Current Age / Age at Death',
                    answer: ''
                }
            }
        }
    }
}


export const NRI_RECORDS = () => {
    return {
        NRI_QUESTIONS: {//section
            NRIQUESTIONS: {//QuestionsetCd 
                ALPHABETWOSPECIALCHAR1: {//Dataelementcd
                    question: 'Nationality',
                    answer: ''
                },
                COUNTRYELEMENT2: {//Dataelementcd
                    question: 'Country of current residence',
                    answer: ''
                },
                DATEELEMENT1: {//Dataelementcd
                    question: 'Date from which you become a permanent resident of the country mentioned above:',
                    answer: ''
                },
                DATEELEMENT2: {
                    question: 'Date of leaving India for the first time:',
                    answer: ''
                },
                ALPHABETWOSPECIALCHAR2: {
                    question: 'Duration of your stay abroad',
                    answer: ''
                },
                FREETEXT2: {
                    question: 'Full address while abroad',
                    answer: ''
                },
                ALPHABETWOSPECIALCHAR4: {
                    question: 'Intended duration of stay abroad',
                    answer: ''
                },
                DATEELEMENT3: {
                    question: 'Date of coming to India (Entry Date)',
                    answer: ''
                }
            },
            EXITDATE: {
                YESNODATAELEMENT8: {
                    question: 'Are you still in India?',
                    answer: ''
                },
                DATEELEMENT1: {
                    question: 'Date you last left India (Exit Date)',
                    answer: ''
                }
            },
            PURPOSEOFSTAY: {
                ALPHABETWITHSPECIALCHAR: {
                    question: 'Purpose of your stay aboard:',
                    answer: ''
                }
            },
            NRIPHYSICIANDETAILS: {
                ALPHABETWITHSPECIALCHAR: {
                    question: 'The name of your regular Medical physician:',
                    answer: ''
                },
                CONTACTNOELEMENT1: {
                    question: 'Tel nos of your regular Medical physician:',
                    answer: ''
                },
                ALPHABETWITHSPECIALCHAR1: {
                    question: 'Address of your regular Medical physician:',
                    answer: ''
                },
                FREETEXT4: {
                    question: 'E-mail Id of your regular Medical physician:',
                    answer: ''
                }
            },
            PASSPORTDETAILS: {
                FREETEXT1: {
                    question: 'Passport Number',
                    answer: ''
                },
                FREETEXT2: {
                    question: 'Place of Issue',
                    answer: ''
                },
                DATEELEMENT1: {
                    question: 'Date of Issue',
                    answer: ''
                },
                DATEELEMENT2: {
                    question: 'Date of Expiry',
                    answer: ''
                }
            },
            NRIINDIAAC: {
                YESNODATAELEMENT1: {
                    question: 'Do you hold any bank account in India?',
                    answer: ''
                }

            },
            NRIBANKACCOUNTTYPE: {
                BANKACELEMENT1: {
                    question: 'Please specify whether it is a Resident /Non-Resident (External) Account',
                    answer: ''
                }
            },
            BANKBLOCKED: {
                YESNODATAELEMENT2: {
                    question: 'Has the bank account ever been blocked?',
                    answer: ''
                },
                FREETEXT1: {
                    question: 'Please furnish full details thereof.',
                    answer: ''
                }
            },
            PROPOSEREMIT: {
                REMITPURPOSEELEMENT1: {
                    question: 'Indicate method by which you propose to remit the premiums to the Company:',
                    answer: ''
                }
            }
        }
    }
}

export const INSURANCE_RECORDS = () => {
    return {
        INSURANCE_HISTORY: {//section
            INSURANCEHISTORY: {//QuestionsetCd 
                YESNODATAELEMENT1: {//Dataelementcd
                    question: 'Do you have any existing Life Insurance cover that you bought from Bharti AXA Life/ or have made any similar application for Life cover with Bharti AXA Life and other insurers?',
                    answer: ''
                },
                FREETEXT2: {
                    question: 'Policy/Proposal No',
                    answer: ''
                },
                FREETEXT1: {
                    question: 'Name of Company',
                    answer: ''
                },
                DATEELEMENT1: {
                    question: 'Date of issue/proposal',
                    answer: ''
                },
                INTEGERELEMENT1: {
                    question: 'Sum Assured',
                    answer: ''
                },
                POLICYSTATUSELEMENT1: {
                    question: 'In Force/Lapsed',
                    answer: ''
                }
            },
            DECLINEDPOLICY: {//QuestionsetCd 
                YESNODATAELEMENT1: {//Dataelementcd
                    question: 'Details of declined/postponed proposals?',
                    answer: ''
                },
                FREETEXT1: {
                    question: 'Name of Company',
                    answer: ''
                },
                ALPHABETWOSPECIALCHAR1: {
                    question: 'Reason',
                    answer: ''
                },
                INTEGERELEMENT1: {
                    question: 'When (Year)',
                    answer: ''
                }
            }
        }
    }
}

export const FAMILY_INCOME_RECORDS = () => {
    return {
        FAMILY_INCOME_FAMILY_INSURANCE: {//section
            FAMILYINCOMEINS: {//QuestionsetCd 
                RELATIONELEMENT2: {//Dataelementcd
                    question: 'Relationship to Life to be Insured',
                    answer: ''
                },
                INTEGERELEMENT1: {
                    question: 'Total Sum Assured',
                    answer: ''
                },
                INTEGERELEMENT2: {
                    question: 'Income',
                    answer: ''
                }
            },
            FAMILYINCINS1: {//QuestionsetCd 
                RELATIONELEMENT3: {//Dataelementcd
                    question: 'Relationship to Life to be Insured',
                    answer: ''
                },
                INTEGERELEMENT1: {
                    question: 'Total Sum Assured',
                    answer: ''
                },
                INTEGERELEMENT2: {
                    question: 'Income',
                    answer: ''
                }
            },
            FAMILYINCINS11: {//QuestionsetCd 
                RELATIONELEMENT2: {//Dataelementcd
                    question: 'Relationship to Life to be Insured',
                    answer: ''
                },
                INTEGERELEMENT1: {
                    question: 'Total Sum Assured',
                    answer: ''
                },
                INTEGERELEMENT2: {
                    question: 'Income',
                    answer: ''
                }
            },
            FAMILYINCINS2: {//QuestionsetCd 
                RELATIONELEMENT4: {//Dataelementcd
                    question: 'Relationship to Life to be Insured',
                    answer: ''
                },
                INTEGERELEMENT1: {
                    question: 'Total Sum Assured',
                    answer: ''
                },
                INTEGERELEMENT2: {
                    question: 'Income',
                    answer: ''
                }
            },
            FAMILYINCINS3: {//QuestionsetCd 
                RELATIONELEMENT3: {//Dataelementcd
                    question: 'Relationship to Life to be Insured',
                    answer: ''
                },
                INTEGERELEMENT1: {
                    question: 'Total Sum Assured',
                    answer: ''
                }
            },
            FAMILYINCINSMINOR: {//QuestionsetCd 
                YESNODATAELEMENT2: {//Dataelementcd
                    question: 'Are all the Siblings Insured?',
                    answer: ''
                },
                ALPHABETWOSPECIALCHAR1: {
                    question: 'Give details:',
                    answer: ''
                }
            }
        }
    }
}